import { TARIFF_PLANS } from '../../constants';
import { StandardPricing } from './pricing/standard';
import { AdvancedPricing } from './pricing/advanced';
import { PlusPricing } from './pricing/advanced_plus';

export const RiskFactor = ({ plan }) => {
  if (plan === TARIFF_PLANS.standard) return <StandardPricing />;
  if (plan === TARIFF_PLANS.advanced) return <AdvancedPricing />;
  if (plan === TARIFF_PLANS.plus) return <PlusPricing />;
  return null;
};
